import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import EmailIcon from "@mui/icons-material/Email";

export default function StepEmailInput({ value, error, onChange }) {
  return (
    <TextField
      label="E-mail"
      placeholder="sua@empresa.com"
      variant="outlined"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      sx={{ mt: 2 }}
      error={Boolean(error)}
      helperText={error}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <EmailIcon sx={{ color: "#5e1bbb" }} />
          </InputAdornment>
        ),
      }}
    />
  );
}
